import { AoAnimationInput, AoConfig } from './types';

const itemDefaults = {
  removeOnComplete: true,
  complete: false,
};

// const locale =
//   new URLSearchParams(window.location.search).get('locale') ?? 'en-US';

const aoConfig: AoAnimationInput[] = [
  {
    name: 'ORIENTATION_CHANGE',
    url: './static/media/global/anim/toVertical_ScreenRotation_v002.json',
    unique: true,
    style: {
      position: 'relative',
      width: 'auto',
      height: '41.3vh',
    },
  },
];

aoConfig.forEach((item, index) => {
  aoConfig[index] = { ...itemDefaults, ...item };
});

export default aoConfig as AoConfig;
